/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magnifying_glass': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22 14.5A7.5 7.5 0 1114.5 7a7.508 7.508 0 017.5 7.5zm6.706 14.207a1 1 0 01-1.414 0l-5.403-5.403a11.514 11.514 0 111.414-1.414l5.403 5.403a1 1 0 010 1.414zM14.499 24A9.5 9.5 0 105 14.5a9.51 9.51 0 009.5 9.5z" _fill="#003B71"/>'
  }
})
